import { useQuery } from "@tanstack/react-query";

export const useSearchKeywords = () => {
  return useQuery({
    queryKey: ["useSearchKeywords"],
    queryFn: async (): Promise<string[]> => {
      const json = await fetch("/sdk-api/api/v1/search-keyword/");

      if (json.ok) {
        const result = await json.json();
        return result.message;
      }

      return ["vrchat"];
    },
  });
};
